import OwlCarousel from 'react-owl-carousel3';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";
import toast from 'react-hot-toast';
import Currency from './Currency';

import LocalizedStrings from 'react-localization';
import localizations from "../../localization";

let strings = new LocalizedStrings(localizations);

/**
 * Countdown hook for sale ribbon.
 *
 * @param {Date|null} targetDate
 * @returns {{days:number,hours:number,minutes:number,seconds:number}}
 */
const useCountdown = (targetDate) => {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const countDownDate = useRef(targetDate ? new Date(targetDate).getTime() : null);
  
    useEffect(() => {
      if (!countDownDate.current) return;
      const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = countDownDate.current - now;
  
        if (distance < 0) {
          clearInterval(timerId);
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        } else {
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          setTimeLeft({ days, hours, minutes, seconds });
        }
      };
      const timerId = setInterval(updateCountdown, 1000);
      updateCountdown();
      return () => clearInterval(timerId);
    }, [targetDate]);
  
    return timeLeft;
  };

/**
 * Calculate express delivery range.
 *
 * @param {number} days
 * @returns {string}
 */
const getDeliveryRange = (days) => {
    try {
        const start = new Date();
        const end = new Date();

        start.setDate(start.getDate() + Number(days));
        end.setDate(end.getDate() + Number(days) + 1);

        const startDay = start.toLocaleDateString('en-GB', { day: 'numeric' });
        const endDayMonth = end.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });

        return `${startDay} - ${endDayMonth}`;
    } catch (error) {
        return '';
    }
};

/**
 * Normalize product data for local rendering/state updates.
 *
 * @param {object} product
 * @returns {object}
 */
const normalizeProduct = (product) => ({
    ...product,
    initialAttributes: product.attributes && product.attributes.length > 0
        ? product.attributes[0].attribute_values
        : [],
    originalProductId: product.originalProductId || product.id,
});

const ProductItem = ({
    item,
    index,
    sale,
    handleFavourite,
    handleSelectVariant,
    selectedVariants,
    showAddtoCart
}) => {
    const countdownTarget = item.sale_time > 0
        ? new Date(Date.now() + item.sale_time * 60000)
        : null;

    const { days, hours, minutes, seconds } = useCountdown(countdownTarget);
    const shouldDisplayCountdown = countdownTarget !== null;

    const selectedVariant = selectedVariants[item.originalProductId] || {};
    const currentMainImage =
        selectedVariant.image ||
        (item.product_images && item.product_images[0] && item.product_images[0].image) ||
        item.image;

    return (
        <div className="col_2 col-4 col-sm-4 col-md-6 col-lg-4 col-xl-3 col_5">
            <div className="arrival-prd">
                <div className="badge-stack">
                    {item.trending_product == 1 && (
                        <div className="badge badge-trending">
                            🔥 TRENDING
                        </div>
                    )}

                    {(item.out_of_stock == 1 || item.left <= 0 || item.sold_out == 1 || item.discontinue == 1) && (
                        <div className="badge badge-out">
                            OUT OF STOCK
                        </div>
                    )}

                    {item.is_coming_soon == 1 && (
                        <div className="badge badge-coming">
                            ⏳ COMING SOON
                        </div>
                    )}

                    {item.is_new == 1 && (
                        <div className="badge badge-new">
                            + NEW
                        </div>
                    )}

                    {item.is_sale == 1 && item.out_of_stock <= 0 && (
                        <div className="badge badge-sale">
                            {Math.round(((item.original_price - item.discount_price) * 100) / item.original_price)}% SALE
                        </div>
                    )}
                </div>

                <div className="arrival-prd-img">
                    <Link to={`/product-detail/${item.slug}`} target="_blank">
                        {item.product_images && item.product_images.length >= 2 ? (
                            <div className="img-container">
                                <img src={currentMainImage} alt={item.name} className="default-img" />
                                <img src={item.product_images[1].image} alt={item.name} className="hover-img" />
                            </div>
                        ) : (
                            <div className="img-container">
                                <img src={currentMainImage} alt={item.name} />
                            </div>
                        )}
                    </Link>

                    <div className="fav-absolute">
                        <button
                            type="button"
                            className={`fav-btn ${item.is_wishlist == 1 ? 'active' : ''}`}
                            onClick={(e) =>
                                handleFavourite(
                                    e,
                                    item.id,
                                    item.is_wishlist == 1 ? 'remove' : 'add',
                                    index
                                )
                            }
                        >
                            <svg viewBox="0 0 24 24" className="heart-icon" aria-hidden="true">
                                <path d="M12 21s-6.7-4.35-9.33-7.07C-0.24 11.02.13 6.8 3.4 4.6 5.5 3.17 8.24 3.88 10 5.6l2 2 2-2c1.76-1.72 4.5-2.43 6.6-1 3.27 2.2 3.64 6.42.73 9.33C18.7 16.65 12 21 12 21z" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="arrival-cont">
                    <div className="sold_rate">
                        {item.rating > 0 && (
                        <div className="rating-new">
                            <span className="star">★</span>
                            <span className="rating">{item.rating}</span>
                            <span className="count">({item.total_rating_count})</span>
                        </div>
                        )}
                        <div className="sold_dtl">
                        <p>{item.sold > 0 ? `${item.sold} ${strings.sold} & ${item.left} ${strings.left}` : `${item.left} ${strings.left}`}</p>
                        </div>
                    </div>

                    {shouldDisplayCountdown ? (
                        <div className="badge-top ribbon-sale">
                            Special sale: {days}d {hours.toString().padStart(2, '0')}:
                            {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
                        </div>
                    ) : item.is_megadeal == 1 ? (
                        <div className="badge-top ribbon-mega">
                            Mega Deal 📣
                        </div>
                    ) : null}

                    <div className="arrival-title">
                        <h3><Link to={`/product-detail/${item.slug}`} style={{textDecoration: 'none'}} target="_blank">{item.name}</Link></h3>
                        {item.brands?.name && (
                            <Link to={`/brand/${item.brands.slug}`} style={{ textDecoration: 'none' }}>
                                <p className="prd-brand-name">{item.brands.name}</p>
                            </Link>
                        )}
                        {item.ai_reason && (
                            <p className="ai-reason-text">{item.ai_reason}</p>
                        )}
                    </div>

                    <div className="arrival-price">
                        <p>
                            <Currency data={item.discount_price != 0 ? item.discount_price : item.original_price} />
                        </p>

                        {parseInt(item.discount_price) == 0
                            ? ''
                            : (
                                <p className="discount-price">
                                    <span><Currency data={item.original_price} /></span>
                                </p>
                            )
                        }
                    </div>

                    {/* Tester notice */}
                    {item.is_tester && (
                        <div className="tester-notice">
                        {strings.is_tester}
                        </div>
                    )}

                    {item.special_slider_data && (() => {
                        try {
                            const sliderData = typeof item.special_slider_data === 'string'
                                ? JSON.parse(item.special_slider_data)
                                : item.special_slider_data;

                            if (!Array.isArray(sliderData) || sliderData.length === 0) {
                                return null;
                            }

                            const duplicated = [...sliderData, ...sliderData];

                            return (
                                <div className="special-slider-vertical">
                                    <div className="slider-vertical-track">
                                        {duplicated.map((slide, i) => (
                                            <div className="slide-item" key={i}>
                                                {slide.image && <img src={slide.image} alt="" />}
                                                {slide.text && <span>{slide.text}</span>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        } catch (error) {
                            return null;
                        }
                    })()}
                </div>

                {item.initialAttributes && item.initialAttributes.some(
                    (variant) => variant.product_images && variant.product_images.length > 0
                ) && (
                    <OwlCarousel
                        className='owl-theme variant-carousel'
                        loop={false}
                        margin={10}
                        nav
                        items={5}
                    >
                        {item.initialAttributes.map((variant, idx) => (
                            variant.product_images && variant.product_images.length > 0 && (
                                variant.product_images.map((image, imgIdx) => (
                                    <div
                                        key={`${variant.id}-${imgIdx}`}
                                        className={`rounded-image ${selectedVariant.imgIdx === imgIdx ? 'selected-image' : ''}`}
                                        onClick={() => {
                                            handleSelectVariant(
                                                item.originalProductId,
                                                variant.id,
                                                imgIdx,
                                                index,
                                                image.id,
                                                image.image
                                            );
                                        }}
                                    >
                                        <img src={image.image} alt={String(image.id)} />
                                    </div>
                                ))
                            )
                        ))}
                    </OwlCarousel>
                )}

                {item.express_delivery_days > 0 && (
                    <div className="express-delivery">
                        <span className="express-badge">express</span>
                        <span>
                            Get it by {getDeliveryRange(item.express_delivery_days)}
                        </span>
                    </div>
                )}

                {/* actions */}
                <div className="prd-add-option">
                <div className="cart_wrap">
                    <Link
                    onClick={(e) => {
                        if (item.is_coming_soon == 1) e.preventDefault();
                        else if ((item.out_of_stock == 0) || (item.left > 0)) showAddtoCart(e, item, item.attributes);
                        else window.location.href = `/product-detail/${item.slug}`;
                    }}
                    className={
                        item.is_coming_soon == 1 ? "btn_primary notify_me_new coming_soon" :
                        (item.out_of_stock == 1 || item.left <= 0) ? "btn_primary notify_me_new" : "btn_primary"
                    }
                    target="_blank"
                    >
                    {(item.out_of_stock == 1 || item.left <= 0 || item.is_coming_soon == 1)
                        ? strings.notifyMe : strings.add_to_bag}
                    </Link>
                </div>
                </div>
            </div>
        </div>
    );
};

const ProductList = (Props) => {
    const [currentLang] = useState(
        localStorage.getItem("current_lang")
            ? localStorage.getItem("current_lang")
            : "en"
    );

    const [products, setProducts] = useState([]);
    const [selectedVariants, setSelectedVariants] = useState({});

    strings.setLanguage(currentLang);

    useEffect(() => {
        try {
            const mappedProducts = (Props.data || []).map((product) => normalizeProduct(product));
            setProducts(mappedProducts);
        } catch (error) {
            setProducts([]);
        }
    }, [Props.data]);

    const handleSelectVariant = async (productId, variantId, imgIdx, productIndex, imageId, image) => {
        try {
            const path = `${apiPath.ProductAvailability}/${productId}`;
            const data = new FormData();

            data.append('attribute_value_id', variantId);

            const result = await Http(path, {
                method: 'POST',
                data
            });

            if (result.status === 200 && result.data.status) {
                const updatedProducts = [...products];

                updatedProducts[productIndex] = normalizeProduct({
                    ...result.data.data.product,
                    initialAttributes: updatedProducts[productIndex].initialAttributes,
                    originalProductId: updatedProducts[productIndex].originalProductId
                });

                setProducts(updatedProducts);

                setSelectedVariants((prevState) => ({
                    ...prevState,
                    [productId]: {
                        variant_id: variantId,
                        imgIdx,
                        id: imageId,
                        image
                    }
                }));

                return;
            }

            toast.error(result?.data?.message || 'Error fetching product data');
        } catch (error) {
            toast.error('Error fetching product data');
        }
    };

    const handleFavourite = async (e, id, type, index) => {
        try {
            e.preventDefault();
            e.stopPropagation();

            const path = apiPath.AddRemoveWishlist;
            const data = new FormData();

            data.append('product_id', id);
            data.append('type', type);

            const result = await Http(path, { method: 'POST', data });

            if (result.status === 200 && result.data.status) {
                const updatedProducts = [...products];

                updatedProducts[index] = {
                    ...updatedProducts[index],
                    is_wishlist: type === 'add' ? 1 : 0
                };

                setProducts(updatedProducts);
                toast.success(result.data.message);
                return;
            }

            toast.error(result?.data?.message || result.statusText || 'Error updating wishlist');
        } catch (error) {
            toast.error('Error updating wishlist');
        }
    };

    return (
        <>
            {products.map((item, index) => (
                <ProductItem
                    key={item.id || index}
                    item={item}
                    index={index}
                    sale={Props.sale}
                    handleFavourite={handleFavourite}
                    handleSelectVariant={handleSelectVariant}
                    selectedVariants={selectedVariants}
                    showAddtoCart={Props.showAddtoCart}
                />
            ))}
        </>
    );
};

export default ProductList;
